import DeleteIcon from '@mui/icons-material/Delete'
import { Button } from '@mui/material'
import DropDownOA from '../common/dropDownOA'
import { useState } from 'react'
import { useEffect } from 'react'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../common/jotaiState/commonStateAtoms'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from '../../i18n/I18nProvider'
import { getStaStatusLabel, getTrackCardLabels } from '../header/lrTrackingPopupConstants'
export const LrTrackCard = (props) => {
  const { data, lastStatus, isEditable, loginData, vehicleList, cityList, branchList, visibilityFlag, isLastStatus } = props
  const { translations } = useTranslation()
  const l = getTrackCardLabels(translations)
  const [searchParams, setSearchParams] = useSearchParams()
  const [isEdit, setIsEdit] = useState(false)
  const [resetFlag, setResetFlage] = useState(false)
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID: companyCurrencyID } = companySettings || {};
  const DefaultCurrencyID = companyCurrencyID ?? (searchParams.get('dc') ? Number(searchParams.get('dc')) : 0);
  const [dispatchDetail, setDispatchDetail] = useState({
    intToCityID: data.DispatchedToCityID,
    intToBranchID: data.DispatchedToBranchID,
    strVehicleNo: data.VehicleNo,
    intVehicleID: data.VehicleID,
  })
  const [bookingDetail, setBookingDetail] = useState({
    DestinationCityID: data.DestinationCityID,
    DestinationBranchID: data.DestinationBranchId,
  })
  const [branchTransferDetails, setBranchTransferDetails] = useState({
    intToCityID: data.DispatchedToCityID,
    intToBranchID: data.DispatchedToBranchID,
    strVehicleNo: data.VehicleNo,
    intVehicleID: data.VehicleID,
  })
  useEffect(() => {
    let cityId = 0
    if (props?.lastStatus?.TYPE === 'B') {
      cityId = props?.lastStatus?.DestinationCityID
    } else if (props?.lastStatus?.TYPE === 'T') {
      cityId = props?.lastStatus?.DispatchedToCityID
    } else if (props?.lastStatus?.TYPE === 'D') {
      cityId = props?.lastStatus?.DispatchedToCityID
    } else if (props?.lastStatus?.TYPE === 'L') {
      cityId = props?.lastStatus?.DispatchedToCityID
    }
    props.handleBranch && props.handleBranch(cityId)
  }, [props?.lastStatus])

  const isAPP = data.TypeDet.endsWith('-App') ? 'App' : ''
  // const status = data.TypeDet.endsWith('-App') ? data.TypeDet.slice(0, data.TypeDet.length - 4) : data.TypeDet
  // console.log(status, 'status')
  let status = data.TypeDet.endsWith('-App') ? data.TypeDet.slice(0, -4) : data.TypeDet;
  if (DefaultCurrencyID === 2) {
    status = getStaStatusLabel(status, translations)
  }
  const IsShortReceived = data.TYPE === 'D' && data.IsShortReceived === 1
  switch (data.TYPE) {
    case 'B':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dateAndTime}</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading bkg-status red">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.source}</div>
                <div className="lrt-details">{data.FromCity || data.SourceCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.destinationCity}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    defaultvalue={data.DestinationCity || ''}
                    // value={data.DispatchedToCity}
                    data={cityList.filter((val) => val.CityID !== data.SourceCityID) || []}
                    width="100%"
                    searchPlaceholder={l.searchByCity}
                    tabIndex="2"
                    typeOf={1}
                    isObjArr={true}
                    dataKey={`CityName`}
                    idKey={`CityID`}
                    onSelect={(e) => {
                      setResetFlage(true)
                      props.handleBranch(e.CityID)
                      // dispatchDetail
                      setBookingDetail({ ...bookingDetail, DestinationCityID: e.CityID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToCity || data.DestinationCity}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.sourceBranch}</div>
                <div className="lrt-details">{data.BranchName || data.SourceBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.destinationBranch}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList || []}
                    defaultvalue={data.DestinationBranch || ''}
                    width="100%"
                    searchPlaceholder={l.searchByBranch}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setBookingDetail({ ...bookingDetail, DestinationBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToBranchName || data.DestinationBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.bookedByUser}</div>
                <div className="lrt-details">{data.TransactionByUser || data.BookedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading"></div>
                <div className="lrt-details"></div>
              </div>
            </div>

            <div
              className="lrt-card-row"
              style={{
                textAlign: 'center',
                display:
                  lastStatus?.TYPE === data.TYPE &&
                  visibilityFlag?.AllowAdminSendAndRecChange === 1 &&
                  visibilityFlag?.AllowAdminDestinationChange === 1 &&
                  loginData.intCompanyID !== STA_COMPANY_ID
                    ? ''
                    : 'none',
              }}
            >
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  {l.edit}
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleBookingUpdate(data, bookingDetail)
                    //props.
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  {l.save}
                </Button>
              </div>
            </div>
          </div>
        </>
      )
    case 'D':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dateAndTime}</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                {isEditable === 'update' && isLastStatus && visibilityFlag?.AllowAdminCancelDispatch === 1 ? (
                  <span
                    onClick={(e) => {
                      props.handleCancelDispatch(data)
                    }}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                ) : (
                  ''
                )}
                <div className="lrt-heading bkg-status blue">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dispatchedFrom}</div>
                <div className="lrt-details">{data.FromCity || data.DispatchedFromCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.dispatchedTo}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    defaultvalue={data.DispatchedToCity || ''}
                    // value={data.DispatchedToCity}
                    data={cityList.filter((val) => val.CityID !== data.DispatchedFromCityID) || []}
                    width="100%"
                    searchPlaceholder={l.searchByCity}
                    tabIndex="2"
                    typeOf={1}
                    isObjArr={true}
                    dataKey={`CityName`}
                    idKey={`CityID`}
                    onSelect={(e) => {
                      setResetFlage(true)
                      props.handleBranch(e.CityID)
                      // dispatchDetail
                      setDispatchDetail({ ...dispatchDetail, intToCityID: e.CityID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToCity || data.DispatchedToCity}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dispatchedFromBranch}</div>
                <div className="lrt-details">{data.DispatchedFromBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.dispatchedToBranch}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList || []}
                    defaultvalue={data.DispatchedToBranch || ''}
                    width="100%"
                    searchPlaceholder={l.searchByBranch}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setDispatchDetail({ ...dispatchDetail, intToBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.BranchName || data.DispatchedToBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dispatchedByUser}</div>
                <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.dispatchedInVehicle}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={vehicleList || []}
                    defaultvalue={data.VehicleNo}
                    width="100%"
                    searchPlaceholder={l.searchBy}
                    isObjArr={true}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleNo`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setDispatchDetail({ ...dispatchDetail, strVehicleNo: e.VehicleNo })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.VehicleNo}</div>
                )}
              </div>
            </div>
            <div
              className="lrt-card-row"
              style={{
                textAlign: 'center',
                display: lastStatus?.TYPE === data.TYPE && visibilityFlag?.AllowAdminDispatchChange === 1 ? '' : 'none',
              }}
            >
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  {l.edit}
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleDispatchUpdate(data, dispatchDetail)
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  {l.save}
                </Button>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.driverName}</div>
                <div className="lrt-details">{data.DriverConductorName}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.driverNumber}</div>
                <div className="lrt-details">{data.ContactNo}</div>
              </div>
            </div>
          </div>
          {IsShortReceived && (
            <>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.dateAndTime}</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">{l.shortReceived}</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.byUser}</div>
                    <div className="lrt-details">{ data.ShortReceivedByUserName}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading"></div>
                    <div className="lrt-details"></div>
                  </div>
                </div>
              </div>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.dateAndTime}</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">{l.back}</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.backToCity}</div>
                    <div className="lrt-details">{data.FromCity}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.backFromCity}</div>
                    <div className="lrt-details">{data.ToCity}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.backToBranch}</div>
                    <div className="lrt-details">{data.DispatchedFromBranch}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.backFromBranch}</div>
                    <div className="lrt-details">{data.BranchName}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.byUser}</div>
                    <div className="lrt-details">{data.TransactionByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.dispatchedInVehicle}</div>
                    <div className="lrt-details">{data.VehicleNo}</div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )
    case 'T':
      return (
        <>
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dateAndTime}</div>
                <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                {/* {isEditable === 'update' && visibilityFlag?.AllowAdminCancelBranchTransReceive === 1 ? ( */}
                {isEditable === 'update' && isLastStatus && visibilityFlag?.AllowAdminCancelDispatch === 1 ? (
                  <span
                    onClick={(e) => {
                      props.handleCancelBranchTransfer(data)
                    }}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                ) : (
                  ''
                )}
                <div className="lrt-heading bkg-status blue">{status}</div>
                <div className="lrt-details">{isAPP}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.transferFrom}</div>
                <div className="lrt-details">{data.FromCity || data.DispatchedFromCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.transferredTo}</div>
                <div className="lrt-details">{data.ToCity || data.DispatchedToCity}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.transferFromBranch}</div>
                <div className="lrt-details">{data.BranchName}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.transferredToBranch}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={branchList.filter((val) => val.BranchID !== data.DispatchedFromBranchID) || []}
                    defaultvalue={data.DispatchedToBranch || ''}
                    width="100%"
                    searchPlaceholder={l.searchByBranch}
                    isObjArr={true}
                    dataKey={`BranchName`}
                    idKey={`BranchID`}
                    tabIndex="5"
                    resetFlag={resetFlag}
                    onSelect={(e) => {
                      setResetFlage(false)
                      setBranchTransferDetails({ ...branchTransferDetails, intToBranchID: e.BranchID })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.ToBranchName || data.DispatchedToBranch}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.transferredByUser}</div>
                <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.transferredByVehicle}</div>

                {lastStatus?.TYPE === data.TYPE && isEdit ? (
                  <DropDownOA
                    data={vehicleList || []}
                    defaultvalue={data.VehicleNo}
                    width="100%"
                    searchPlaceholder={l.searchBy}
                    isObjArr={true}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleNo`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setBranchTransferDetails({ ...branchTransferDetails, strVehicleNo: e.VehicleNo })
                    }}
                  />
                ) : (
                  <div className="lrt-details">{data.VehicleNo}</div>
                )}
              </div>
            </div>
            <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                  //  onKeyDown={(e) => {}}
                  disabled={isEdit}
                >
                  {l.edit}
                </Button>
              </div>
              <div className="input--wrapper small_space" style={{ padding: '8px' }}>
                <Button
                  // id={iid.searchLrButton}
                  className="select-lr-btn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => {
                    setIsEdit(false)
                    props.handleBranchTransferUpdate(data, branchTransferDetails)
                  }}
                  disabled={!isEdit}
                //  onKeyDown={(e) => {}}
                >
                  {l.save}
                </Button>
              </div>
            </div>
          </div>
          {IsShortReceived && (
            <>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.dateAndTime}</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">{l.shortReceived}</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.byUser}</div>
                    <div className="lrt-details">{data.TransactionByUser || data.DispatchedByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading"></div>
                    <div className="lrt-details"></div>
                  </div>
                </div>
              </div>
              <div className="lrt-card">
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.dateAndTime}</div>
                    <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading bkg-status blue">{l.back}</div>
                    <div className="lrt-details">{isAPP}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.backToCity}</div>
                    <div className="lrt-details">{data.FromCity}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.backFromCity}</div>
                    <div className="lrt-details">{data.ToCity}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.backToBranch}</div>
                    <div className="lrt-details"></div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.backFromBranch}</div>
                    <div className="lrt-details">{data.BranchName}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.byUser}</div>
                    <div className="lrt-details">{data.TransactionByUser}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.dispatchedInVehicle}</div>
                    <div className="lrt-details">{data.VehicleNo}</div>
                  </div>
                </div>
                <div className="lrt-card-row">
                  <div className="lrt-card-row-left box-padding">
                    <div className="lrt-heading">{l.driverName}</div>
                    <div className="lrt-details">{data.DriverConductorName}</div>
                  </div>
                  <div className="lrt-card-row-right box-padding">
                    <div className="lrt-heading">{l.driverNumber}</div>
                    <div className="lrt-details">{data.ContactNo}</div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )
    case 'R':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dateAndTime}</div>
              <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' && isLastStatus && visibilityFlag?.AllowAdminCancelReceive === 1 ? (
                <span
                  onClick={(e) => {
                    props.handleCancelReceive(data)
                  }}
                  style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                >
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dispatchedBy}</div>
              <div className="lrt-details">{data.FromCity || data.DispatchedBy}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.receivedBy}</div>
              <div className="lrt-details">{data.ToCity || data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dispatchedByBranch}</div>
              <div className="lrt-details">{data.DispatchedFromBranch}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.receivedByBranch}</div>
              <div className="lrt-details">{data.BranchName || data.ReceivedByBranch}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.receivedByUser}</div>
              <div className="lrt-details">{data.TransactionByUser || data.ReceivedByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.driverName}</div>
              <div className="lrt-details">{data.DriverConductorName}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.driverNumber}</div>
              <div className="lrt-details">{data.ContactNo}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading"></div>
              <div className="lrt-details"></div>
            </div>
          </div>
        </div>
      )
    case 'G':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dateAndTime}</div>
              <div className="lrt-details">{data.DTTime || data.EventDateTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' && visibilityFlag?.AllowAdminCancelReceive === 1 ? (
                <span
                  onClick={(e) => {
                    props.handleCancelBranchTransferReceive(data)
                  }}
                  style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                >
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.transferFrom}</div>
              <div className="lrt-details">{data.FromCity || data.DispatchedBy}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.transferredAt}</div>
              <div className="lrt-details">{data.ToCity || data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.transferFromBranch}</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.transferReceivedAtBranch}</div>
              <div className="lrt-details">{data.ToBranchName || data.ReceivedByBranch}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.transferReceivedByVehicle}</div>
              <div className="lrt-details">{data.VehicleNo}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.transferReceivedByUser}</div>
              <div className="lrt-details">{data.TransactionByUser || data.ReceivedByUser}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.driverName}</div>
              <div className="lrt-details">{data.DriverConductorName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.driverNumber}</div>
              <div className="lrt-details">{data.ContactNo}</div>
            </div>
          </div>
        </div>
      )
    case 'F':
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dateAndTime}</div>
              <div className="lrt-details">{data.DTTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading bkg-status blue"></div>
              {isEditable === 'update' ? (
                <span style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status green-text">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.deliveredAt}</div>
              <div className="lrt-details">{data.ToCity}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.recipientName}</div>
              <div className="lrt-details">{data.ReceivedBy}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.deliveredByBranch}</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.recipientNumber}</div>
              <div className="lrt-details">{data.ReceiverMobileNo}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.deliveredBy}</div>
              <div className="lrt-details">{data.TransactionByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.deliveryVehicle}</div>
              <div className="lrt-details">{data.VehicleNo}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.remark}</div>
              <div className="lrt-details">{data.Remarks}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading"></div>
              <div className="lrt-details"></div>
            </div>
          </div>
          <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(true)
                }}
                //  onKeyDown={(e) => {}}
                disabled={isEdit}
              >
                {l.edit}
              </Button>
            </div>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(false)
                }}
                disabled={!isEdit}
              //  onKeyDown={(e) => {}}
              >
                {l.save}
              </Button>
            </div>
          </div>
        </div>
      )
      case 'L':
        return (
          <div className="lrt-card">
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.dateAndTime}</div>
                <div className="lrt-details">{data.EventDateTime}</div>
              </div>
              <div className="lrt-card-row-right box-padding" style={{display:'flex',padding:'0px',alignItems:'center',justifyContent:'space-between',paddingLeft:'10px'}}>
                <div className="lrt-heading bkg-status red">{l.lost}</div>
                <div className="lrt-card-row-right box-padding" style={{cursor:'pointer'}}>
                  <span onClick={(e) => {props.handleMarkedAsLost(data)}}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span>
                  {/* <span onClick={(e) => {props.handleCancelDispatch(data)}}
                    style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}
                  >
                    <DeleteIcon />
                  </span> */}
                </div>
                <div className="lrt-details">{isAPP}</div>
              </div>
  
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.source}</div>
                <div className="lrt-details">{data.FromCity || data.SourceCity}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.destinationCity}</div>
                <div className="lrt-details">{data.DestinationCity}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.sourceBranch}</div>
                <div className="lrt-details">{data.SourceBranch}</div>
              </div>
              <div className="lrt-card-row-right box-padding">
                <div className="lrt-heading">{l.destinationBranch}</div>
                <div className="lrt-details">{data.DestinationBranch}</div>
              </div>
            </div>
            <div className="lrt-card-row">
              <div className="lrt-card-row-left box-padding">
                <div className="lrt-heading">{l.markedAsLostByUser}</div>
                <div className="lrt-details">{data.MarkAsLostByUser}</div>
              </div>
            </div>
          </div>
        )
    default:
      return (
        <div className="lrt-card">
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.dateAndTime}</div>
              <div className="lrt-details">{data.DTTime}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {isEditable === 'update' ? (
                <span style={{ float: 'right', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
                  <DeleteIcon />
                </span>
              ) : (
                ''
              )}
              <div className="lrt-heading bkg-status blue ">{status}</div>
              <div className="lrt-details">{isAPP}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.source}</div>
              <div className="lrt-details">{data.FromCity}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.destination}</div>
              <div className="lrt-details">{data.ToCity}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.sourceBranch}</div>
              <div className="lrt-details">{data.BranchName}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              <div className="lrt-heading">{l.destinationBranch}</div>
              <div className="lrt-details">{data.ToBranchName}</div>
            </div>
          </div>
          <div className="lrt-card-row">
            <div className="lrt-card-row-left box-padding">
              <div className="lrt-heading">{l.transactionByUser}</div>
              <div className="lrt-details">{data.TransactionByUser}</div>
            </div>
            <div className="lrt-card-row-right box-padding">
              {data.TYPE === 'C' ? (
                <>
                  <div className="lrt-heading">{l.remark}</div>
                  <div className="lrt-details">{data.Remarks}</div>
                </>
              ) : (
                <>
                  <div className="lrt-heading"></div>
                  <div className="lrt-details"></div>
                </>
              )}
            </div>
          </div>
          <div className="lrt-card-row" style={{ textAlign: 'center', display: lastStatus?.TYPE === data.TYPE ? '' : 'none' }}>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(true)
                }}
                //  onKeyDown={(e) => {}}
                disabled={isEdit}
              >
                {l.edit}
              </Button>
            </div>
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                // id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                onClick={() => {
                  setIsEdit(false)
                }}
                disabled={!isEdit}
              //  onKeyDown={(e) => {}}
              >
                {l.save}
              </Button>
            </div>
          </div>
        </div>
      )
  }
}
